import type { IconSvgObject } from './types';

const Plug02Icon: IconSvgObject = [
  ["path", { d: "M12 17V21C12 21.5523 11.551 22.0053 11.0014 21.9508C5.9474 21.4497 2 17.1858 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 16.4292 19.1204 20.1859 15.1312 21.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 11H8.5V13.6972C8.5 13.8946 8.55844 14.0877 8.66795 14.2519L10.2031 16.5547C10.3886 16.8329 10.7008 17 11.0352 17H12.9648C13.2992 17 13.6114 16.8329 13.7969 16.5547L15.3321 14.2519C15.4416 14.0877 15.5 13.8946 15.5 13.6972V11H14M10 11V9M10 11H14M14 11V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Plug02Icon;
